import { countries } from 'constants/countries';

export const getCountriesPhoneNumberPrefixOptionValues = () => countries
  .filter(country => !!country.phone?.length)
  .map(country => ({
    label: `${country.emoji} ${country.name}`,
    options: country.phone?.map(phone => ({
      label: phone,
      value: phone,
    })),
  }));
